var exports = {
  "o1": "x31de4314--7ce552--actions",
  "Qs": "x31de4314--7ce552--content",
  "DD": "x31de4314--7ce552--title",
  "z3": "x31de4314--7ce552--error",
  "IQ": "x31de4314--7ce552--download_btn_wrapper",
};

module.exports = exports;
